import React from "react";
import {RangeInputStyles} from "../styles/Inputs";
import PropTypes from "prop-types";

const RangeInput = ({ title, value, onChange, name, min, max }) => {
    return (
        <div>
            <div>{title}</div>
            <RangeInputStyles type="range" name={name}
                              min={min.toString()} max={max.toString()} value={value} onChange={onChange} />
        </div>
    )
};

RangeInput.propTypes = {    
    title: PropTypes.string,
    value: PropTypes.number,
    onChange: PropTypes.func,
    name: PropTypes.string,
    min: PropTypes.number,
    max: PropTypes.number,
};

export default RangeInput;